import {connect} from 'react-redux';
import {EndSimulation as Component} from './EndSimulation';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    // id: ownProps.id,
    // type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
    // volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume,
    // minVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].minVol,
    // maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
    // volChange: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volChange
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const EndSimulation = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
